import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, mergeProps as _mergeProps, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createSlots as _createSlots, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ml-2"
}
const _hoisted_2 = { width: "10%" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { width: "5%" }
const _hoisted_7 = { width: "5%" }
const _hoisted_8 = { width: "10%" }
const _hoisted_9 = ["colspan"]
const _hoisted_10 = { width: "5%" }
const _hoisted_11 = { width: "5%" }
const _hoisted_12 = {
  colspan: "6",
  style: {"text-align":"center"}
}
const _hoisted_13 = { style: {"width":"85vw"} }
const _hoisted_14 = { style: {"width":"80vw"} }
const _hoisted_15 = { width: "60%" }
const _hoisted_16 = {
  width: "30%",
  style: {"font-size":"smaller","font-style":"italic"}
}
const _hoisted_17 = { width: "10%" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { colspan: "2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_combobox_filled = _resolveComponent("v-combobox-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_ScopeManager = _resolveComponent("ScopeManager")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_autocomplete_filled = _resolveComponent("v-autocomplete-filled")!
  const _component_v_btn_add_icon = _resolveComponent("v-btn-add-icon")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "default_card large mx-0 my-2 pa-2 fill-height sticky-card",
        elevation: "0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            class: "py-1",
            style: {"flex-wrap":"nowrap"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                class: "d-flex headline align-center",
                cols: "9"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn_back, {
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$router.go(-1)), ["stop"]))
                  }),
                  _createVNode(_component_v_text_field_filled, {
                    modelValue: _ctx.title,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.title) = $event)),
                    label: "Le titre de votre tableau personnalisé",
                    rules: [_ctx.rules.notEmpty],
                    "hide-details": "",
                    "single-line": "",
                    class: "pl-1",
                    outlined: "",
                    readonly: _ctx.readOnly,
                    density: "compact"
                  }, null, 8, ["modelValue", "rules", "readonly"]),
                  _createVNode(_component_v_select_filled, {
                    outlined: "",
                    modelValue: _ctx.use,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.use) = $event)),
                    items: _ctx.uses,
                    label: "Usage",
                    class: "pl-1",
                    "hide-details": "",
                    density: "compact"
                  }, null, 8, ["modelValue", "items"]),
                  _createVNode(_component_v_combobox_filled, {
                    modelValue: _ctx.range,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.range) = $event)),
                    label: "Définissez la portée",
                    class: "pl-1",
                    multiple: "",
                    chips: "",
                    closable: "",
                    "hide-details": "",
                    "item-disabled": "",
                    rules: [_ctx.rules.onlyNumbers],
                    readonly: _ctx.readOnly
                  }, null, 8, ["modelValue", "rules", "readonly"]),
                  (_ctx.type !== 'BALANCE_SHEET')
                    ? (_openBlock(), _createBlock(_component_v_select_filled, {
                        key: 0,
                        modelValue: _ctx.type,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.type) = $event)),
                        items: _ctx.types,
                        label: "Type",
                        class: "pl-1 d-flex flex-grow-0 flex-shrink-1",
                        "hide-details": "",
                        density: "compact"
                      }, null, 8, ["modelValue", "items"]))
                    : (_openBlock(), _createBlock(_component_v_text_field_filled, {
                        key: 1,
                        label: "Type",
                        "hide-details": "",
                        "single-line": "",
                        class: "pl-1 d-flex flex-grow-1 flex-shrink-0",
                        readonly: "",
                        "model-value": 'Bilan',
                        density: "compact"
                      }))
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { class: "d-flex justify-end align-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn_icon, _mergeProps({
                        icon: "$oss-duplicate",
                        class: "elevation-0 mr-3",
                        color: "secondary"
                      }, props, {
                        disabled: _ctx.type === 'BALANCE_SHEET',
                        onClick: _ctx.duplicate,
                        size: "small"
                      }), null, 16, ["disabled", "onClick"])
                    ]),
                    default: _withCtx(() => [
                      _cache[44] || (_cache[44] = _createElementVNode("span", null, "Dupliquer", -1))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_tooltip, {
                    disabled: !_ctx.disabledTable,
                    location: "bottom"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createElementVNode("div", _normalizeProps(_guardReactiveProps(props)), [
                        _createVNode(_component_v_btn, {
                          rounded: "",
                          elevation: "0",
                          class: "ml-0",
                          disabled: _ctx.disabledTable,
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.dialogTab = true)),
                          size: "small"
                        }, {
                          default: _withCtx(() => _cache[45] || (_cache[45] = [
                            _createTextVNode(" Tableau ")
                          ])),
                          _: 1
                        }, 8, ["disabled"])
                      ], 16)
                    ]),
                    default: _withCtx(() => [
                      _cache[46] || (_cache[46] = _createElementVNode("span", null, " Définissez une portée pour voir les comptes non utilisés", -1))
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_v_btn, {
                    rounded: "",
                    elevation: "0",
                    class: "ml-2",
                    disabled: _ctx.isDisabled || _ctx.readOnly,
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.upsertOperatingAccount(false))),
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(this.idSheet === null ? "Créer" : " Sauver "), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_v_btn, {
                    rounded: "",
                    elevation: "0",
                    class: "ml-2",
                    disabled: !_ctx.isFinished || _ctx.readOnly || !!!_ctx.scopeId,
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.upsertOperatingAccount(true))),
                    size: "small"
                  }, {
                    default: _withCtx(() => _cache[47] || (_cache[47] = [
                      _createTextVNode(" Valider ")
                    ])),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card, {
        elevation: "0",
        style: _normalizeStyle('max-height:' + _ctx.maxHeight + ';' + 'overflow:auto')
      }, {
        default: _withCtx(() => [
          (_ctx.OutOfPCF)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 0,
                "no-gutters": "",
                class: "d-flex"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        size: "x-small",
                        color: "error"
                      }, {
                        default: _withCtx(() => _cache[48] || (_cache[48] = [
                          _createTextVNode("$fa-exclamation-triangle")
                        ])),
                        _: 1
                      }),
                      _cache[49] || (_cache[49] = _createTextVNode(" Attention certaines lignes débordent du plan comptable (enlever les nombres en rouge) "))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (
                    _ctx.AArestants.length !== 0 &&
                    _ctx.range.length !== 0 &&
                    _ctx.accountableAccountsUsed.length !== 0
                )
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 1,
                "no-gutters": "",
                class: "d-flex"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        size: "x-small",
                        color: "orange"
                      }, {
                        default: _withCtx(() => _cache[50] || (_cache[50] = [
                          _createTextVNode("$fa-exclamation-triangle")
                        ])),
                        _: 1
                      }),
                      _cache[51] || (_cache[51] = _createTextVNode(" Attention certains comptes comptables de la portée n'ont pas été rentrés (cliquer sur TABLEAU, en haut à droite) "))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.doublons.length !== 0 && _ctx.accountableAccountsUsed.length !== 0)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 2,
                "no-gutters": "",
                class: "d-flex"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        size: "x-small",
                        color: "orange"
                      }, {
                        default: _withCtx(() => _cache[52] || (_cache[52] = [
                          _createTextVNode("$fa-exclamation-triangle")
                        ])),
                        _: 1
                      }),
                      _cache[53] || (_cache[53] = _createTextVNode(" Attention certains comptes comptables sont présents plusieurs fois (chercher les nombres en orange) "))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.OA_Tables.length)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 3,
                class: "d-flex py-1"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.OA_Tables, (table, ti) => {
                    return (_openBlock(), _createBlock(_component_v_col, {
                      cols: "12",
                      key: ti + '_Tables'
                    }, {
                      default: _withCtx(() => [
                        (_ctx.OA_Tables.length > 1)
                          ? (_openBlock(), _createElementBlock("h1", _hoisted_1, _toDisplayString(table.name), 1))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_data_table, {
                          headers: _ctx.headers(table),
                          items: table.rows,
                          "items-per-page": -1,
                          "hide-default-footer": "",
                          class: "table"
                        }, _createSlots({
                          item: _withCtx((props) => [
                            (props.item.name)
                              ? (_openBlock(), _createElementBlock("tr", {
                                  key: props.item.index
                                }, [
                                  _createElementVNode("td", _hoisted_2, [
                                    (props.index != 0)
                                      ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                          key: 0,
                                          icon: "$fa-angle-up",
                                          class: "justify-start",
                                          size: "x-small",
                                          color: "secondary",
                                          elevation: "0",
                                          onClick: ($event: any) => (_ctx.swapRow2(props.index, props.index - 1, ti)),
                                          disabled: _ctx.readOnly
                                        }, null, 8, ["onClick", "disabled"]))
                                      : _createCommentVNode("", true),
                                    (props.index !== table.rows.length - 1)
                                      ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                          key: 1,
                                          icon: "$fa-angle-down",
                                          class: "justify-end",
                                          size: "x-small",
                                          color: "secondary",
                                          elevation: "0",
                                          onClick: ($event: any) => (_ctx.swapRow2(props.index, props.index + 1, ti)),
                                          disabled: _ctx.readOnly
                                        }, null, 8, ["onClick", "disabled"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("td", null, _toDisplayString(props.item.name), 1),
                                  (!props.item.marginRatio)
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.tableColumns(table), (col, ci) => {
                                        return (_openBlock(), _createElementBlock("td", {
                                          key: ci + '_Column'
                                        }, [
                                          (
                                                props.item.columns && props.item.columns[col.value]
                                            )
                                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(props.item.columns[
                                                    col.value
                                                ], (condition, i) => {
                                                return (_openBlock(), _createElementBlock("span", {
                                                  key: i + '_Condition'
                                                }, [
                                                  (condition.startsWith)
                                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(condition.startsWith, (accountableAccount, i) => {
                                                        return (_openBlock(), _createElementBlock("span", {
                                                          key: i + '_Numbers'
                                                        }, [
                                                          _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                                            activator: _withCtx(({ props }) => [
                                                              (
                                                                        !_ctx.scopedAccountableAccounts ||
                                                                        !_ctx.scopedAccountableAccounts.length
                                                                    )
                                                                ? (_openBlock(), _createBlock(_component_v_chip, _mergeProps({
                                                                    key: 0,
                                                                    color: "secondary",
                                                                    class: "mx-1",
                                                                    ref_for: true
                                                                  }, props, { size: "small" }), {
                                                                    default: _withCtx(() => [
                                                                      _createTextVNode(_toDisplayString(_ctx.displayVChip(
                                                                            accountableAccount,
                                                                        )), 1)
                                                                    ]),
                                                                    _: 2
                                                                  }, 1040))
                                                                : (
                                                                        _ctx.checkNumberAAconcerned(
                                                                            accountableAccount,
                                                                        ) === 0
                                                                    )
                                                                  ? (_openBlock(), _createBlock(_component_v_chip, _mergeProps({
                                                                      key: 1,
                                                                      color: "error",
                                                                      class: "mx-1",
                                                                      ref_for: true
                                                                    }, props, { size: "small" }), {
                                                                      default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(_ctx.displayVChip(
                                                                            accountableAccount,
                                                                        )), 1)
                                                                      ]),
                                                                      _: 2
                                                                    }, 1040))
                                                                  : (
                                                                        _ctx.isOverflowRange(
                                                                            accountableAccount,
                                                                        )
                                                                    )
                                                                    ? (_openBlock(), _createBlock(_component_v_chip, _mergeProps({
                                                                        key: 2,
                                                                        color: "error",
                                                                        class: "mx-1",
                                                                        ref_for: true
                                                                      }, props, { size: "small" }), {
                                                                        default: _withCtx(() => [
                                                                          _createTextVNode(_toDisplayString(_ctx.displayVChip(
                                                                            accountableAccount,
                                                                        )), 1)
                                                                        ]),
                                                                        _: 2
                                                                      }, 1040))
                                                                    : (
                                                                        _ctx.isDoublon(
                                                                            accountableAccount,
                                                                        )
                                                                    )
                                                                      ? (_openBlock(), _createBlock(_component_v_chip, _mergeProps({
                                                                          key: 3,
                                                                          color: "orange",
                                                                          class: "mx-1",
                                                                          ref_for: true
                                                                        }, props, { size: "small" }), {
                                                                          default: _withCtx(() => [
                                                                            _createTextVNode(_toDisplayString(_ctx.displayVChip(
                                                                            accountableAccount,
                                                                        )), 1)
                                                                          ]),
                                                                          _: 2
                                                                        }, 1040))
                                                                      : (_openBlock(), _createBlock(_component_v_chip, _mergeProps({
                                                                          key: 4,
                                                                          color: "secondary",
                                                                          class: "mx-1",
                                                                          ref_for: true
                                                                        }, props, { size: "small" }), {
                                                                          default: _withCtx(() => [
                                                                            _createTextVNode(_toDisplayString(_ctx.displayVChip(
                                                                            accountableAccount,
                                                                        )), 1)
                                                                          ]),
                                                                          _: 2
                                                                        }, 1040))
                                                            ]),
                                                            default: _withCtx(() => [
                                                              (
                                                                    _ctx.isOverflowRange(
                                                                        accountableAccount,
                                                                    ) &&
                                                                    _ctx.checkNumberAAconcerned(
                                                                        accountableAccount,
                                                                    ) !== 0
                                                                )
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Ce compte déborde de la portée. "))
                                                                : (
                                                                    _ctx.isDoublon(accountableAccount)
                                                                )
                                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Comprend des comptes présents en double. "))
                                                                  : _createCommentVNode("", true),
                                                              _createElementVNode("span", null, "Nombre de comptes concernés : " + _toDisplayString(_ctx.checkNumberAAconcerned(
                                                                        accountableAccount,
                                                                    )), 1)
                                                            ]),
                                                            _: 2
                                                          }, 1024)
                                                        ]))
                                                      }), 128))
                                                    : _createCommentVNode("", true),
                                                  (condition.notStartsWith)
                                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(condition.notStartsWith, (notStartsWith, i) => {
                                                        return (_openBlock(), _createElementBlock("span", {
                                                          key: i + '_notStartsWith'
                                                        }, [
                                                          _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                                            activator: _withCtx(({ props }) => [
                                                              _createVNode(_component_v_chip, _mergeProps({
                                                                color: "primary",
                                                                class: "mr-1",
                                                                ref_for: true
                                                              }, props, { size: "small" }), {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(_toDisplayString(_ctx.displayVChip(notStartsWith)), 1)
                                                                ]),
                                                                _: 2
                                                              }, 1040)
                                                            ]),
                                                            default: _withCtx(() => [
                                                              _createElementVNode("span", null, "Nombre de comptes concernés : " + _toDisplayString(_ctx.checkNumberAAconcerned(
                                                                        notStartsWith,
                                                                    )), 1)
                                                            ]),
                                                            _: 2
                                                          }, 1024)
                                                        ]))
                                                      }), 128))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              }), 128))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128))
                                    : (_openBlock(), _createElementBlock("td", _hoisted_5, _toDisplayString("( " +
                                        _ctx.findTitle(props.item.input.key1) +
                                        " / " +
                                        _ctx.findTitle(props.item.input.key2) +
                                        " )"), 1)),
                                  _createElementVNode("td", _hoisted_6, [
                                    _createVNode(_component_v_btn_icon, {
                                      icon: "$oss-edit",
                                      class: "justify-end",
                                      color: "secondary",
                                      elevation: "0",
                                      onClick: ($event: any) => (_ctx.editRow2(props.index, ti)),
                                      disabled: _ctx.readOnly,
                                      size: "x-small"
                                    }, null, 8, ["onClick", "disabled"])
                                  ]),
                                  _createElementVNode("td", _hoisted_7, [
                                    _createVNode(_component_v_btn_trash, {
                                      class: "justify-end",
                                      size: "x-small",
                                      onClick: ($event: any) => (_ctx.removeRow2(props.index, ti)),
                                      disabled: _ctx.readOnly
                                    }, null, 8, ["onClick", "disabled"])
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("tr", {
                                  key: props.item.index + '_title',
                                  style: {"background-color":"rgb(230, 230, 230)"}
                                }, [
                                  _createElementVNode("td", _hoisted_8, [
                                    (props.index != 0)
                                      ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                          key: 0,
                                          icon: "$fa-angle-up",
                                          class: "justify-start",
                                          size: "x-small",
                                          color: "secondary",
                                          elevation: "0",
                                          onClick: ($event: any) => (_ctx.swapRow2(props.index, props.index - 1, ti)),
                                          disabled: _ctx.readOnly
                                        }, null, 8, ["onClick", "disabled"]))
                                      : _createCommentVNode("", true),
                                    (props.index !== table.rows.length - 1)
                                      ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                          key: 1,
                                          icon: "$fa-angle-down",
                                          class: "justify-end",
                                          size: "x-small",
                                          color: "secondary",
                                          elevation: "0",
                                          onClick: ($event: any) => (_ctx.swapRow2(props.index, props.index + 1, ti)),
                                          disabled: _ctx.readOnly
                                        }, null, 8, ["onClick", "disabled"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("td", {
                                    colspan: _ctx.tableColumns(table).length + 1,
                                    style: {"font-weight":"bold"}
                                  }, _toDisplayString(props.item.title), 9, _hoisted_9),
                                  _createElementVNode("td", _hoisted_10, [
                                    _createVNode(_component_v_btn_icon, {
                                      icon: "$oss-edit",
                                      class: "justify-end",
                                      color: "secondary",
                                      elevation: "0",
                                      onClick: ($event: any) => (_ctx.editTotal2(props.index, ti)),
                                      disabled: _ctx.readOnly,
                                      size: "x-small"
                                    }, null, 8, ["onClick", "disabled"])
                                  ]),
                                  _createElementVNode("td", _hoisted_11, [
                                    _createVNode(_component_v_btn_trash, {
                                      class: "justify-end",
                                      size: "x-small",
                                      onClick: ($event: any) => (_ctx.removeRow2(props.index, ti)),
                                      disabled: _ctx.readOnly
                                    }, null, 8, ["onClick", "disabled"])
                                  ])
                                ]))
                          ]),
                          _: 2
                        }, [
                          (_ctx.type !== 'BALANCE_SHEET')
                            ? {
                                name: "body.append",
                                fn: _withCtx(() => [
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("td", _hoisted_12, [
                                      _createVNode(_component_v_btn, {
                                        size: "small",
                                        elevation: "0",
                                        class: "ml-4",
                                        onClick: _cache[8] || (_cache[8] = ($event: any) => {
                                            _ctx.edit = false;
                                            _ctx.dialogAddOrEditRow = true;
                                        }),
                                        disabled: _ctx.readOnly
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_icon, {
                                            size: "large",
                                            left: "",
                                            class: "pr-2"
                                          }, {
                                            default: _withCtx(() => _cache[54] || (_cache[54] = [
                                              _createTextVNode("$fa-plus")
                                            ])),
                                            _: 1
                                          }),
                                          _cache[55] || (_cache[55] = _createTextVNode(" Ajouter "))
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"]),
                                      _createVNode(_component_v_btn, {
                                        size: "small",
                                        elevation: "0",
                                        class: "ml-4",
                                        onClick: _cache[9] || (_cache[9] = ($event: any) => {
                                            _ctx.edit = false;
                                            _ctx.dialogChooseSig = true;
                                        }),
                                        disabled: _ctx.readOnly
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_icon, {
                                            size: "large",
                                            left: "",
                                            class: "pr-2"
                                          }, {
                                            default: _withCtx(() => _cache[56] || (_cache[56] = [
                                              _createTextVNode("$fa-plus")
                                            ])),
                                            _: 1
                                          }),
                                          _cache[57] || (_cache[57] = _createTextVNode(" Solde Intermédiaire "))
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"]),
                                      _createVNode(_component_v_btn, {
                                        size: "small",
                                        elevation: "0",
                                        class: "ml-4",
                                        onClick: _cache[10] || (_cache[10] = ($event: any) => {
                                            _ctx.edit = false;
                                            _ctx.dialogAddTotal = true;
                                        }),
                                        disabled: _ctx.readOnly
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_icon, {
                                            size: "large",
                                            left: "",
                                            class: "pr-2"
                                          }, {
                                            default: _withCtx(() => _cache[58] || (_cache[58] = [
                                              _createTextVNode("$fa-plus")
                                            ])),
                                            _: 1
                                          }),
                                          _cache[59] || (_cache[59] = _createTextVNode(" Total "))
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"]),
                                      _createVNode(_component_v_btn, {
                                        size: "small",
                                        elevation: "0",
                                        class: "ml-4",
                                        onClick: _cache[11] || (_cache[11] = ($event: any) => {
                                            _ctx.edit = false;
                                            _ctx.dialogAddRatio = true;
                                        }),
                                        disabled: _ctx.readOnly
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_icon, {
                                            size: "large",
                                            left: "",
                                            class: "pr-2"
                                          }, {
                                            default: _withCtx(() => _cache[60] || (_cache[60] = [
                                              _createTextVNode("$fa-plus")
                                            ])),
                                            _: 1
                                          }),
                                          _cache[61] || (_cache[61] = _createTextVNode(" Taux "))
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"])
                                    ])
                                  ])
                                ]),
                                key: "0"
                              }
                            : undefined
                        ]), 1032, ["headers", "items"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["style"]),
      _createVNode(_component_ScopeManager, {
        ref: "scopeManager",
        modelValue: _ctx.scopeSync,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.scopeSync) = $event)),
        id: _ctx.scopeId,
        "onUpdate:id": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.scopeId) = $event)),
        name: _ctx.scopeName,
        "onUpdate:name": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.scopeName) = $event)),
        readonly: _ctx.readOnly
      }, null, 8, ["modelValue", "id", "name", "readonly"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.dialogAddOrEditRow,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.dialogAddOrEditRow) = $event)),
        title: _ctx.edit ? 'Modifier la ligne' : 'Ajouter une ligne'
      }, {
        actions: _withCtx(() => [
          _createVNode(_component_v_btn_primary, {
            disabled: !_ctx.isValid,
            rounded: "",
            block: "",
            onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.edit ? _ctx.validateModificatedRow() : _ctx.validateNewRow())),
            size: "x-large"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.edit ? "Modifier" : "Ajouter"), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_v_form, {
              modelValue: _ctx.isValid,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.isValid) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "11",
                      class: "title px-3 pt-2"
                    }, {
                      default: _withCtx(() => _cache[62] || (_cache[62] = [
                        _createTextVNode(" Nom de la ligne ")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "11",
                      class: "d-flex justify-center align-top mx-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field_filled, {
                          modelValue: _ctx.newNameRow,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.newNameRow) = $event)),
                          rules: [_ctx.rules.notEmpty, _ctx.rules.rowNameDoesntExist],
                          label: "Description de la nouvelle ligne",
                          density: "compact"
                        }, null, 8, ["modelValue", "rules"]),
                        _createVNode(_component_v_checkbox, {
                          modelValue: _ctx.newDisplaySignRow,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.newDisplaySignRow) = $event)),
                          label: "Inverser le signe",
                          "false-value": -1,
                          "true-value": 1,
                          class: "ma-0",
                          hint: "Si coché, les charges seront de signe positif (et les produits de signe négatif)",
                          "persistent-hint": "",
                          density: "compact"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "title pl-3 pt-2"
                    }, {
                      default: _withCtx(() => _cache[63] || (_cache[63] = [
                        _createTextVNode(" Conditions ")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "pl-3 pt-2"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newRulesRow, (cont, index) => {
                          return (_openBlock(), _createBlock(_component_v_row, {
                            "no-gutters": "",
                            key: index + '_' + _ctx.refreshKey,
                            class: "d-flex justify-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "1",
                                class: "d-flex align-center justify-center"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(index !== 0 ? "ET" : "SI"), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_col, {
                                cols: "2",
                                class: "pb-1"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_select_filled, {
                                    modelValue: cont.operator,
                                    "onUpdate:modelValue": ($event: any) => ((cont.operator) = $event),
                                    items: _ctx.operators,
                                    rules: [_ctx.rules.notEmpty],
                                    density: "compact"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "rules"])
                                ]),
                                _: 2
                              }, 1024),
                              (cont.operator === 'equalTo')
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 0,
                                    cols: "5",
                                    class: "pb-1 pl-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_autocomplete_filled, {
                                        modelValue: cont.numbers,
                                        "onUpdate:modelValue": ($event: any) => ((cont.numbers) = $event),
                                        items: _ctx.scopedAccountableAccounts,
                                        "item-title": (item) => _ctx.displayVChip(item.name || item),
                                        "item-value": (item) => item.name,
                                        rules: [_ctx.rules.notEmptyAutocomplete],
                                        label: "l'un de ces comptes comptables",
                                        chips: "",
                                        multiple: "",
                                        "closable-chips": ""
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "item-title", "item-value", "rules"])
                                    ]),
                                    _: 2
                                  }, 1024))
                                : (cont.operator === 'startsWith')
                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                      key: 1,
                                      cols: "5",
                                      class: "d-flex align-center justify-center pl-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_combobox_filled, {
                                          modelValue: cont.numbers,
                                          "onUpdate:modelValue": ($event: any) => ((cont.numbers) = $event),
                                          label: "un de ces comptes racines",
                                          "item-title": (item) => _ctx.displayVChip(item),
                                          multiple: "",
                                          chips: "",
                                          "closable-chips": "",
                                          "item-disabled": "",
                                          density: "compact",
                                          disabled: !cont.operator,
                                          rules: [_ctx.rules.notEmptyAutocomplete, _ctx.rules.onlyNumbers],
                                          "append-inner-icon": "$fa-ban",
                                          "onClick:appendInner": ($event: any) => (_ctx.displayNotStartsWith(cont))
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "item-title", "disabled", "rules", "onClick:appendInner"]),
                                        _withDirectives(_createVNode(_component_v_combobox_filled, {
                                          modelValue: cont.notStartsWith,
                                          "onUpdate:modelValue": ($event: any) => ((cont.notStartsWith) = $event),
                                          label: "Et ne démarre pas par",
                                          multiple: "",
                                          chips: "",
                                          "closable-chips": "",
                                          density: "compact",
                                          items: _ctx.scopedAccountableAccounts,
                                          "item-value": (item) => item.name,
                                          "item-title": (item) => _ctx.displayVChip(item.name || item),
                                          "return-object": false,
                                          rules: [_ctx.rules.onlyNumbers]
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "item-value", "item-title", "rules"]), [
                                          [_vShow, 
                                            (cont.notStartsWith && cont.notStartsWith.length) ||
                                            cont.displayNotStartsWith
                                        ]
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true),
                              (
                                        cont.operator === 'startsWith' ||
                                        cont.operator === 'equalTo'
                                    )
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 2,
                                    cols: "3",
                                    class: "pb-1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_select_filled, {
                                        modelValue: cont.debitOrCredit,
                                        "onUpdate:modelValue": ($event: any) => ((cont.debitOrCredit) = $event),
                                        items: _ctx.operatorsDebitOrCredit,
                                        class: "ml-2",
                                        density: "compact"
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
                                    ]),
                                    _: 2
                                  }, 1024))
                                : (_openBlock(), _createBlock(_component_v_col, {
                                    key: 3,
                                    cols: "8"
                                  })),
                              _createVNode(_component_v_col, {
                                col: "1",
                                class: "d-flex align-top justify-center"
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.newRulesRow.length > 1)
                                    ? (_openBlock(), _createBlock(_component_v_btn_trash, {
                                        key: 0,
                                        size: "x-small",
                                        onClick: ($event: any) => (_ctx.removeCondition(index))
                                      }, null, 8, ["onClick"]))
                                    : _createCommentVNode("", true),
                                  (index + 1 === _ctx.newRulesRow.length)
                                    ? (_openBlock(), _createBlock(_component_v_btn_add_icon, {
                                        key: 1,
                                        size: "x-small",
                                        onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.addCondition()))
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "title"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.dialogChooseSig,
        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.dialogChooseSig) = $event)),
        title: "Ajouter un solde intermédiaire",
        width: "70vw"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            "no-gutters": "",
            class: "pb-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field_filled, {
                    modelValue: _ctx.searchBar,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.searchBar) = $event)),
                    label: "Rechercher",
                    "single-line": "",
                    density: "compact",
                    clearable: "",
                    "append-inner-icon": "$search",
                    "onClick:clear": _cache[22] || (_cache[22] = ($event: any) => (_ctx.search = ''))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_list, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listIntermediateBalances, (item, index) => {
                return (_openBlock(), _createBlock(_component_v_list_item, {
                  key: item.index,
                  class: _normalizeClass(
                            !_ctx.$vuetify.display.mobile
                                ? 'mb-2 oss-list-item'
                                : 'mb-2 px-2 oss-list-item'
                        ),
                  ripple: true,
                  onClick: ($event: any) => (_ctx.addIntermediaireBalance(item))
                }, {
                  append: _withCtx(() => [
                    _createVNode(_component_v_btn_next)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["class", "onClick"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.dialogAddTotal,
        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.dialogAddTotal) = $event)),
        title: _ctx.edit ? 'Modifier ce total' : 'Ajouter une ligne total'
      }, {
        actions: _withCtx(() => [
          _createVNode(_component_v_btn_primary, {
            disabled: !_ctx.isValid2,
            rounded: "",
            block: "",
            onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.edit ? _ctx.validateModificatedTotal() : _ctx.validateNewTotal())),
            size: "x-large"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.edit ? "Modifier" : "Ajouter"), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_v_form, {
              modelValue: _ctx.isValid2,
              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.isValid2) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "title px-3 pt-2"
                    }, {
                      default: _withCtx(() => _cache[64] || (_cache[64] = [
                        _createTextVNode(" Nom de la ligne totale ")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "11",
                      class: "d-flex justify-center align-top mx-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field_filled, {
                          modelValue: _ctx.newNameRow,
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.newNameRow) = $event)),
                          rules: [_ctx.rules.notEmpty, _ctx.rules.rowNameDoesntExist],
                          label: "Description de la nouvelle ligne",
                          outlined: "",
                          "single-line": "",
                          "hide-details": "",
                          density: "compact"
                        }, null, 8, ["modelValue", "rules"]),
                        _createVNode(_component_v_checkbox, {
                          modelValue: _ctx.newDisplaySignRow,
                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.newDisplaySignRow) = $event)),
                          label: "Inverser le signe",
                          "false-value": -1,
                          "true-value": 1,
                          class: "ma-0 pb-2",
                          hint: "Si coché, les charges seront de signe positif (et les produits de signe négatif)",
                          "persistent-hint": ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "11",
                      class: "d-flex justify-center mx-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select_filled, {
                          modelValue: _ctx.typeOfTotal,
                          "onUpdate:modelValue": [
                            _cache[26] || (_cache[26] = ($event: any) => ((_ctx.typeOfTotal) = $event)),
                            _cache[27] || (_cache[27] = ($event: any) => (_ctx.reinitialiseListTotaux()))
                          ],
                          items: _ctx.itemsTypeOfTotal,
                          class: "mr-2",
                          style: _normalizeStyle(_ctx.itemsTypeOfTotalStyle),
                          density: "compact"
                        }, null, 8, ["modelValue", "items", "style"]),
                        (_ctx.typeOfTotal !== 'justPreviousRows')
                          ? (_openBlock(), _createBlock(_component_v_autocomplete_filled, {
                              key: 0,
                              modelValue: _ctx.listTotauxToAdd,
                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.listTotauxToAdd) = $event)),
                              items: _ctx.itemsToAdd(),
                              "item-value": "key",
                              rules: [_ctx.rules.notEmptyAutocomplete],
                              label: "choisissez les totaux qui s'ajouteront",
                              chips: "",
                              multiple: "",
                              "closable-chips": "",
                              density: "compact"
                            }, null, 8, ["modelValue", "items", "rules"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "title"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.dialogAddRatio,
        "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.dialogAddRatio) = $event)),
        title: _ctx.edit ? 'Modifier ce taux' : 'Ajouter un taux',
        width: "70vw"
      }, {
        actions: _withCtx(() => [
          _createVNode(_component_v_btn_primary, {
            disabled: !_ctx.isValid3,
            rounded: "",
            block: "",
            onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.edit ? _ctx.validateModificatedRatio() : _ctx.validateNewRatio())),
            size: "x-large"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.edit ? "Modifier" : "Ajouter"), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_form, {
            modelValue: _ctx.isValid3,
            "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.isValid3) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "title px-3 pt-2"
                  }, {
                    default: _withCtx(() => _cache[65] || (_cache[65] = [
                      _createTextVNode(" Nom de la ligne (taux) "),
                      _createElementVNode("span", { class: "subtitle-2" }, "x/y (en %)", -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "11",
                    class: "d-flex mx-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        modelValue: _ctx.newNameRow,
                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.newNameRow) = $event)),
                        rules: [_ctx.rules.notEmpty, _ctx.rules.rowNameDoesntExist],
                        label: "Description de la nouvelle ligne",
                        outlined: "",
                        "single-line": "",
                        "hide-details": "",
                        density: "compact"
                      }, null, 8, ["modelValue", "rules"]),
                      _createVNode(_component_v_checkbox, {
                        modelValue: _ctx.newDisplaySignRow,
                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.newDisplaySignRow) = $event)),
                        class: "d-flex align-center",
                        label: "Inverser le signe (charges/produits de signe positif)",
                        "false-value": -1,
                        "true-value": 1
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "11",
                    class: "d-flex justify-center mx-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select_filled, {
                        modelValue: _ctx.newKey1,
                        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.newKey1) = $event)),
                        items: _ctx.rowsWithoutRatios,
                        "item-title": (x) => x.name || x.title,
                        "item-value": (x) => x.key || x.name || x.title,
                        rules: [_ctx.rules.notEmpty],
                        label: "x",
                        outlined: "",
                        density: "compact"
                      }, null, 8, ["modelValue", "items", "item-title", "item-value", "rules"]),
                      _createVNode(_component_v_select_filled, {
                        modelValue: _ctx.newKey2,
                        "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.newKey2) = $event)),
                        items: _ctx.rowsWithoutRatios,
                        "item-title": (x) => x.name || x.title,
                        "item-value": (x) => x.key || x.name || x.title,
                        rules: [_ctx.rules.notEmpty],
                        label: "y",
                        outlined: "",
                        class: "ml-2",
                        density: "compact"
                      }, null, 8, ["modelValue", "items", "item-title", "item-value", "rules"]),
                      _createVNode(_component_v_select_filled, {
                        modelValue: _ctx.newKeyToModify,
                        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.newKeyToModify) = $event)),
                        items: _ctx.toModifyKeys,
                        label: "Valeur à modifier",
                        outlined: "",
                        class: "ml-2",
                        density: "compact"
                      }, null, 8, ["modelValue", "items"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["modelValue", "title"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.dialogTab,
        "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.dialogTab) = $event)),
        title: "Les comptes non attribués",
        width: "70vw"
      }, {
        actions: _withCtx(() => [
          _createVNode(_component_v_btn_primary, {
            disabled: _ctx.selectionTab.length === 0 || _ctx.readOnly,
            rounded: "",
            block: "",
            onClick: _cache[41] || (_cache[41] = ($event: any) => {
                        _ctx.dialogFromTab = true;
                        _ctx.dialogTab = false;
                    }),
            size: "x-large"
          }, {
            default: _withCtx(() => _cache[66] || (_cache[66] = [
              _createTextVNode("Ajouter à une ligne")
            ])),
            _: 1
          }, 8, ["disabled"])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_data_table, {
            headers: _ctx.headers2,
            items: _ctx.AArestants,
            "items-per-page": -1,
            "hide-default-footer": "",
            "no-data-text": "Tous les comptes (tels que définis dans la portée) sont utilisés",
            density: "compact",
            class: "table"
          }, {
            item: _withCtx((props) => [
              (_openBlock(), _createElementBlock("tr", {
                key: props.item.index
              }, [
                _createElementVNode("td", _hoisted_15, _toDisplayString(props.item.displayName || props.item.name) + " - " + _toDisplayString(props.item.description), 1),
                _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.displayDebitCreditOnlyForTab(props.item.name)), 1),
                _createElementVNode("td", _hoisted_17, [
                  (!_ctx.readOnly)
                    ? (_openBlock(), _createBlock(_component_v_checkbox, {
                        key: 0,
                        modelValue: _ctx.selectionTab,
                        "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.selectionTab) = $event)),
                        value: props.item.name
                      }, null, 8, ["modelValue", "value"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            ]),
            _: 1
          }, 8, ["headers", "items"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.dialogFromTab,
        "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.dialogFromTab) = $event)),
        title: "Sélectionnez la ligne où ajouter les comptes",
        width: "70vw"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_data_table, {
            items: _ctx.rulesRows,
            "items-per-page": -1,
            "hide-default-footer": "",
            class: "table"
          }, {
            item: _withCtx((props) => [
              (props.item.name && !props.item.marginRatio)
                ? (_openBlock(), _createElementBlock("tr", {
                    key: props.item.index
                  }, [
                    _createElementVNode("td", null, _toDisplayString(props.item.name), 1),
                    _createElementVNode("td", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.item.netAmounts, (condition, i) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: i + '_Condition'
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(condition.numbers, (accountableAccount, i) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: i + '_Numbers'
                            }, [
                              _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                activator: _withCtx(({ props }) => [
                                  (
                                                    _ctx.checkNumberAAconcerned(accountableAccount) === 0
                                                )
                                    ? (_openBlock(), _createBlock(_component_v_chip, _mergeProps({
                                        key: 0,
                                        color: "error",
                                        class: "mx-1",
                                        ref_for: true
                                      }, props, { size: "small" }), {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(accountableAccount), 1)
                                        ]),
                                        _: 2
                                      }, 1040))
                                    : (_ctx.isOverflowRange(accountableAccount))
                                      ? (_openBlock(), _createBlock(_component_v_chip, _mergeProps({
                                          key: 1,
                                          class: "mx-1",
                                          ref_for: true
                                        }, props, { size: "small" }), {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(accountableAccount), 1)
                                          ]),
                                          _: 2
                                        }, 1040))
                                      : (_openBlock(), _createBlock(_component_v_chip, _mergeProps({
                                          key: 2,
                                          color: "secondary",
                                          class: "mx-1",
                                          ref_for: true
                                        }, props, { size: "small" }), {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(accountableAccount), 1)
                                          ]),
                                          _: 2
                                        }, 1040))
                                ]),
                                default: _withCtx(() => [
                                  (
                                                _ctx.isOverflowRange(accountableAccount) &&
                                                _ctx.checkNumberAAconcerned(accountableAccount) !== 0
                                            )
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Ce compte déborde de la portée. "))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("span", null, "Nombre de comptes concernés : " + _toDisplayString(_ctx.checkNumberAAconcerned(accountableAccount)), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]))
                          }), 128))
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("td", _hoisted_19, [
                      _createVNode(_component_v_btn, {
                        rounded: "",
                        elevation: "0",
                        class: "ml-4",
                        onClick: ($event: any) => (_ctx.integrationAACheckedIntoRulesRows(props.item.name)),
                        size: "small"
                      }, {
                        default: _withCtx(() => _cache[67] || (_cache[67] = [
                          _createTextVNode(" Ajouter ")
                        ])),
                        _: 2
                      }, 1032, ["onClick"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["items"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}